module.exports = __webpack_public_path__ + "img/gaia48-3.f81cc545.png";